// extracted by mini-css-extract-plugin
export default {"wrapper":"DtBua","card-title":"Q3tkT","card-text":"NDDYj","svg":"xMjS_"};